export default "__VITE_ASSET__xmcP_GZ8__"